export const ENDPOINTS = {
    AUTH: "/auth/login",
    SEND_OTP: "/auth/otp",
    AUTH_REFRESH: "/auth/refresh",
    TOTP_QR: "/admin/auth/totp",
    BARCODE_FOOD_SEARCH: "/admin/barcode/food-search",
    BARCODE_FOOD_SEARCH_HUB: "/admin/barcode/food-search/hub",
    BRANCH: "/admin/branch",
    BUNDLE: "/admin/bundle",
    CONSUMABLE_GOOD: "/admin/consumable-good",
    UPDATED_EXCEL: "/admin/upload/updated-excel",
    CONSUMABLE_GOOD_LIST: "/admin/consumable-good/list",
    CONSUMABLE_GOOD_RECEIVING: "/admin/receiving-consumable-good",
    DAILY_REMAINS: "/admin/daily-remains",
    DAILY_REMAINS_V2: "/admin/v2/daily-remains",
    FINANCIAL_Period: `/admin/financial-period`,
    FINANCIAL_Period_NEW: `/admin/financial-period/new`,
    FINANCIAL_Period_Close: (cycleId: number) =>
        `/admin/financial-period/${cycleId}/close`,
    FOOD: "/admin/food",
    HUB: "/admin/hub",
    HUB_OPS: "/admin/hub-ops",
    HUB_OPS_LIST: "/admin/hub-ops/list",
    INVOICE: "/admin/invoice",
    INVOICE_DETAIL: "/admin/invoice/detail",
    INVOICE_MEDIA_REVENUE: "/admin/invoice/media-revenue",
    NOTIFICATION: "/admin/notification",
    OFFLINE_SALE: "/admin/offline-sale",
    ORDER: "/admin/order",
    ORDER_DRY: "/admin/order/dry",
    ORDER_IMPORT: "/admin/order/import",
    ORDER_V2: "/admin/v2/order",
    ORDER_DRY_V2: "/admin/v2/order/dry",
    ORDER_REDRAFT_V2: "/admin/v2/order/redraft",
    ORDER_STATUSES_V2: "/admin/v2/order/statuses",
    ORDER_DRY_STATUSES_V2: "/admin/v2/order/dry/statuses",
    ORDER_CONVERT_V2: "/admin/v2/order/convert-excel/download",
    ORDER_CONVERT_UPLOAD_V2: "admin/v2/order/convert/upload",
    ORDER_PREDICTION_CONVERT_V2: "/admin/v2/order-prediction-convert",
    ORDER_PREDICTION_V2: "/admin/v2/order-prediction",
    QC: "/admin/qc",
    RECEIVING: "/admin/receiving",
    RECEIVING_GOOD: "/admin/receiving/good",
    RECEIVING_DRY: "/admin/receiving/dry",
    STOCK: "/admin/stock",
    STOCK_REASONS: "/admin/stock/reasons",
    TOPPING: "/admin/topping",
    TOPPING_BATCH: "/admin/topping-batch",
    TOPPING_PRODUCT: "/admin/topping-product",
    USER: "/admin/user",
    VENDOR: "/admin/vendor",
    VENDOR_GENERATE_EXCEL: "admin/vendor-excel-generate",
    WASTE: "/admin/waste",
    WASTE_NEW: "/admin/waste/new",
    WASTE_EXPORT_EXCEL: "/admin/waste-excel",
    WEEK_DAY: "/admin/week-day",
    UPLOAD_WASTE_EXCEL: "/admin/vendor-dispatch-reports",
    CUSTOMER: "/admin/customer",
    DASHBOARD_YESTERDAY_REPORT: "/admin/dashboard/yesterday-report",
    DASHBOARD_BESTSELLER_REPORT: "/admin/dashboard/bestseller-report",
    DASHBOARD_SALES_DETAIL: "/admin/dashboard/retail-report",
    DASHBOARD_SALES_DETAIL_EXPORT_EXCEL: "/admin/dashboard/retail-excel",
    GET_DAY_TYPES: "/day-types",
};
